// extracted by mini-css-extract-plugin
export default {"melodyVideo":"PK-z","isFullWidth":"QK-z","landingPageVideo":"RK-z","play":"SK-z","iframeVideo":"TK-z","playHidden":"UK-z","fullwidth":"VK-z"};